// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"89a4789c","315":"8d6d9c82","499":"79a5e6b0"}[chunkId] + ".chunk.css";
};